import { useEffect, useState } from "react";
import { namedChainsApi, type ChainReference } from "./api/named-chains-client";

interface UsageListProps {
  chainId: string;
}

export function UsageList({ chainId }: UsageListProps) {
  const [references, setReferences] = useState<ChainReference[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    namedChainsApi
      .usage(chainId)
      .then((data) => {
        if (!cancelled) setReferences(data.references);
      })
      .catch((err: unknown) => {
        if (!cancelled)
          setError(err instanceof Error ? err.message : "Failed to load usage");
      });
    return () => {
      cancelled = true;
    };
  }, [chainId]);

  if (error) return <div className="admin-error">{error}</div>;
  if (references === null) return <div className="admin-loading"><div className="loading-spinner" /></div>;

  if (references.length === 0) {
    return (
      <div className="rb-section">
        <h2 className="rb-section-title">Usage Panel</h2>
        <div className="tab-placeholder">
          <span className="tab-placeholder-text">
            This chain is not currently referenced by any export mapping.
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="rb-section">
      <h2 className="rb-section-title">Usage Panel</h2>
      <table>
        <thead>
          <tr>
            <th>Destination</th>
            <th>Mapping column</th>
          </tr>
        </thead>
        <tbody>
          {references.map((ref) => (
            <tr key={ref.mappingId}>
              <td>{ref.destinationId}</td>
              <td>{ref.targetColumn}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
